
import StatsStore from './stats'
import AclStore from './acls'
import TokenStore from './token'
import ToastStore from './toast'
import ProgressStore from './progress'
import MsgStore from './msg'
import Keepalive from './keepalive'
// import Menu from './menu'
// import Profile from './profile'
// import Loginbranch from './loginbranch'

// 시스템 용 스토어
const register = () => {
  return [AclStore, StatsStore, ToastStore, TokenStore, ProgressStore, MsgStore, Keepalive]
  // return [AclStore, StatsStore, ToastStore, TokenStore, ProgressStore, MsgStore, Keepalive, Menu, Profile, Loginbranch]
}

let registerLocalStore = {}
registerLocalStore.register = register

export default registerLocalStore



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/register.js